export default __webpack_public_path__ + "static/media/pic-4.b9d9b2d2.png";